import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PageRefreshRequiredEventHandler {
  public async handle(): Promise<void> {
    window.location.reload();
  }
}
